module.exports = __webpack_public_path__ + "img/01.b2d9e3eb.png";